export {
  Slot,
  Slottable,
  //
  Root,
} from './slot';
export type { SlotProps } from './slot';
